export default __webpack_public_path__ + "static/media/home-on.9e047fae.svg";